<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :fixed-header="true"
      :search="search"
      :height="ALTURA_TABELA"
      class="font-resp-tabela"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title class="ml-n3">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Cadastro de Grupo Filial
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>

          <v-spacer></v-spacer>

          <v-text-field
            class="mr-6"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            style="max-width: 450px;"
          ></v-text-field>
          <v-dialog persistent v-model="dialog" max-width="900">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <v-btn
                  color="#000"
                  icon
                  style="margin-left: -10px"
                  @click="close()"
                >
                <v-icon>mdi-close</v-icon>
              </v-btn>
                <span class="headline ml-4">{{ formTitle }}</span>
              </v-card-title>

              <v-divider class="mb-4"></v-divider>

              <v-card-text class="pt-6">
                <v-container>
                  <v-row>
                    <v-col class="pa-0" cols="4" xs="12">
                      <v-autocomplete
                        v-model="editedItem.id_grupo"
                        :items="selects.grupos.items"
                        label="Escolha o Grupo*"
                        autofocus
                        clearable
                        outlined
                        height="10"
                        small-chips
                        class="pr-2"
                        color="#042333"
                        item-text="descricao"
                        item-value="id"
                        :error-messages="descricaoErrors"
                        @input="$v.editedItem.id_grupo.$touch()"
                        @blur="$v.editedItem.id_grupo.$touch()"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col class="pa-0" cols="4" xs="12">
                      <v-text-field
                        v-model="editedItem.filial"
                        label="Escolha a Filial*"
                        clearable
                        outlined
                        small-chips
                        height="4"
                        color="#042333"
                        :error-messages="filialErrors"
                        @input="$v.editedItem.filial.$touch()"
                        @blur="$v.editedItem.filial.$touch()"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="4" xs="12">
                      <v-select
                        v-model="editedItem.filial_cd"
                        :items="selects.filial_cd.items"
                        label="Filial CD*"
                        item-text="value"
                        item-value="id"
                        class="pl-2"
                        height="10"
                        outlined
                        small-chips
                        :error-messages="filialCdErrors"
                        @input="$v.editedItem.filial_cd.$touch()"
                        @blur="$v.editedItem.filial_cd.$touch()"
                      ></v-select>
                    </v-col>
                    <v-col class="pa-0" cols="4" xs="12">
                      <v-select
                        v-model="editedItem.matriz"
                        :items="selects.matriz.items"
                        small-chips
                        label="Matriz*"
                        height="4"
                        outlined
                        class="pr-2"
                        item-value="id"
                        item-text="value"
                        :error-messages="matrizErrors"
                        @input="$v.editedItem.matriz.$touch()"
                        @blur="$v.editedItem.matriz.$touch()"
                      ></v-select>
                    </v-col>
                    <v-col class="pa-0" cols="4" xs="12">
                      <v-select
                        v-model="editedItem.filtro_disponibilidade_drp"
                        :items="selects.filtro_disponibilidade_drp.items"
                        small-chips
                        label="Filtro Disponibilidade DRP*"
                        height="10"
                        outlined
                        item-value="id"
                        item-text="value"
                        :error-messages="filtroDisponibilidadeDrpErrors"
                        @input="
                          $v.editedItem.filtro_disponibilidade_drp.$touch()
                        "
                        @blur="
                          $v.editedItem.filtro_disponibilidade_drp.$touch()
                        "
                      ></v-select>
                    </v-col>
                  <v-col class="pa-0 pb-6" cols="12">
                    <v-divider />
                  </v-col>
                    <v-col  class="pa-0" cols="3">
                      <v-text-field
                        outlined
                        v-model="editedItem.cobertura_drp"
                        label="Cobertura DRP*"
                        type="number"
                        class="pr-2"
                        :error-messages="coberturaDrpErrors"
                        @input="$v.editedItem.cobertura_drp.$touch()"
                        @blur="$v.editedItem.cobertura_drp.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="3">
                      <v-text-field
                        outlined
                        v-model="editedItem.tempo_ressuprimento_drp"
                        label="Tempo Ressuprimento DRP*"
                        class="pl-2 pr-2"
                        type="number"
                        :error-messages="tempoRessuprimentoDrpErrors"
                        @input="$v.editedItem.tempo_ressuprimento_drp.$touch()"
                        @blur="$v.editedItem.tempo_ressuprimento_drp.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="3">
                      <v-text-field
                        outlined
                        v-model="editedItem.limite_cobertura"
                        label="Limite Cobertura"
                        type="number"
                        class="pl-2 pr-2"
                        :error-messages="limiteCoberturaErrors"
                        @input="$v.editedItem.limite_cobertura.$touch()"
                        @blur="$v.editedItem.limite_cobertura.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="3">
                      <v-text-field
                        outlined
                        v-model="editedItem.limite_distribuicao"
                        label="Limite Distribuição"
                        type="number"
                        class="pl-2"
                        :error-messages="limiteDistribuicaoErrors"
                        @input="$v.editedItem.limite_distribuicao.$touch()"
                        @blur="$v.editedItem.limite_distribuicao.$touch()"
                      ></v-text-field>
                    </v-col>
                  <v-col class="pa-0 pb-6" cols="12">
                    <v-divider />
                  </v-col>
                    <v-col class="pa-0" cols="3">
                      <v-text-field
                        outlined
                        v-model="editedItem.cobertura_drp_reverso"
                        label="Cobertura DRP Reverso"
                        type="number"
                        class="pr-2"
                        :error-messages="coberturaDrpReversoErrors"
                        @input="$v.editedItem.cobertura_drp_reverso.$touch()"
                        @blur="$v.editedItem.cobertura_drp_reverso.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="3">
                      <v-text-field
                        outlined
                        v-model="editedItem.tempo_ressuprimento_drp_reverso"
                        label="Tempo Ressup. DRP Reverso"
                        type="number"
                        class="pl-2 pr-2"
                        :error-messages="tempoRessuprimentoDrpReversoErrors"
                        @input="$v.editedItem.tempo_ressuprimento_drp_reverso.$touch()"
                        @blur="$v.editedItem.tempo_ressuprimento_drp_reverso.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="3">
                      <v-text-field
                        outlined
                        v-model="editedItem.limite_cobertura_reverso"
                        label="Limite Cobertura Reverso"
                        type="number"
                        class="pl-2 pr-2"
                        :error-messages="limiteCoberturaReversoErrors"
                        @input="$v.editedItem.limite_cobertura_reverso.$touch()"
                        @blur="$v.editedItem.limite_cobertura_reverso.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="3">
                      <v-text-field
                        outlined
                        v-model="editedItem.limite_distribuicao_reverso"
                        label="Limite Distribuição Reverso"
                        type="number"
                        class="pl-2"
                        :error-messages="limiteDistribuicaoReversoErrors"
                        @input="$v.editedItem.limite_distribuicao_reverso.$touch()"
                        @blur="$v.editedItem.limite_distribuicao_reverso.$touch()"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close">Sair</v-btn>
                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.src_modulo="{ item }">
        <v-icon>{{ item.src_modulo }}</v-icon>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Módulo" class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon title="Remover Módulo" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>

import { required, integer, minValue, maxValue } from "vuelidate/lib/validators";
import Api from "./../../api/cfg";

export default {
  props: ["atualizarGrupoFilial"],
  data: () => ({
    dialog: false,
    search: "",
    headers: [
      {
        text: "ID",
        value: "id_grupo",
      },
      {
        text: "ID Filial",
        value: "filial",
      },
      {
        text: "Grupo",
        align: "left",
        value: "descricao",
      },
      {
        text: "Filial",
        value: "filial",
      },
      {
        text: "Matriz",
        value: "matriz",
      },
      {
        text: "CD",
        value: "filial_cd",
      },
      {
        text: "Filtro Disponibilidade DRP",
        value: "filtro_disponibilidade_drp",
      },
      {
        text: "Data de Cadastro",
        align: "left",
        value: "data_cadastro",
      },
      { text: "Ações", value: "action", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,

    editedItem: {
      id_grupo: "",
      filial: "",
      matriz: "",
      cobertura_drp: "",
      tempo_ressuprimento_drp: "",
      filtro_disponibilidade_drp: "",
      filial_cd: "",
      cobertura_drp_reverso: "",
      tempo_ressuprimento_drp_reverso: "",
      limite_cobertura: "",
      limite_distribuicao: "",
      limite_cobertura_reverso: "",
      limite_distribuicao_reverso: "",
    },
    defaultItem: {
      id_grupo: "",
      filial: "",
      matriz: "",
      cobertura_drp: "",
      tempo_ressuprimento_drp: "",
      filtro_disponibilidade_drp: "",
      filial_cd: "",
      cobertura_drp_reverso: "",
      tempo_ressuprimento_drp_reverso: "",
      limite_cobertura: "",
      limite_distribuicao: "",
      limite_cobertura_reverso: "",
      limite_distribuicao_reverso: "",
    },
    selects: {
      grupos: {
        items: [],
      },
      filias: {
        items: [],
      },
      matriz: {
        items: [
          {
            id: "S",
            value: "SIM",
          },
          {
            id: "N",
            value: "NÃO",
          },
        ],
      },
      filtro_disponibilidade_drp: {
        items: [
          {
            id: "S",
            value: "SIM",
          },
          {
            id: "N",
            value: "NÃO",
          },
        ],
      },
      filial_cd: {
        items: [
          {
            id: "S",
            value: "SIM",
          },
          {
            id: "N",
            value: "NÃO",
          },
        ],
      },
    },
  }),

  validations: {
    editedItem: {
      id_grupo: {
        required,
      },
      filial: {
        required,
        integer,
      },
      matriz: {
        required,
      },
      cobertura_drp: {
        required,
      },
      tempo_ressuprimento_drp: {
        required,
      },
      filtro_disponibilidade_drp: {
        required,
      },
      filial_cd: {
        required,
      },
      cobertura_drp_reverso: {
        integer,
        minValue: minValue(0),
        maxValue: maxValue(99999999)
      },
      tempo_ressuprimento_drp_reverso: {
        integer,
        minValue: minValue(0),
        maxValue: maxValue(99999999)
      },
      limite_cobertura: {
        integer,
        minValue: minValue(0),
        maxValue: maxValue(99999999)
      },
      limite_distribuicao: {
        integer,
        minValue: minValue(0),
        maxValue: maxValue(99999999)
      },
      limite_cobertura_reverso: {
        integer,
        minValue: minValue(0),
        maxValue: maxValue(99999999)
      },
      limite_distribuicao_reveso: {
        integer,
        minValue: minValue(0),
        maxValue: maxValue(99999999)
      },
      limite_distribuicao_reverso: {
        integer,
        minValue: minValue(0),
        maxValue: maxValue(99999999)
      }
    },
  },

  computed: {
    descricaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.id_grupo.$dirty) return errors;
      !this.$v.editedItem.id_grupo.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    filialErrors() {
      const errors = [];
      if (!this.$v.editedItem.filial.$dirty) return errors;
      !this.$v.editedItem.filial.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.filial.integer && errors.push("Apenas números inteiros");
      return errors;
    },
    matrizErrors() {
      const errors = [];
      if (!this.$v.editedItem.matriz.$dirty) return errors;
      !this.$v.editedItem.matriz.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    coberturaDrpErrors() {
      const errors = [];
      if (!this.$v.editedItem.cobertura_drp.$dirty) return errors;
      !this.$v.editedItem.cobertura_drp.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    tempoRessuprimentoDrpErrors() {
      const errors = [];
      if (!this.$v.editedItem.tempo_ressuprimento_drp.$dirty) return errors;
      !this.$v.editedItem.tempo_ressuprimento_drp.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    filtroDisponibilidadeDrpErrors() {
      const errors = [];
      if (!this.$v.editedItem.filtro_disponibilidade_drp.$dirty) return errors;
      !this.$v.editedItem.filtro_disponibilidade_drp.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    filialCdErrors() {
      const errors = [];
      if (!this.$v.editedItem.filial_cd.$dirty) return errors;
      !this.$v.editedItem.filial_cd.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    coberturaDrpReversoErrors() {
      const errors = [];
      if (!this.$v.editedItem.cobertura_drp_reverso.$dirty) return errors;
      !this.$v.editedItem.cobertura_drp_reverso.minValue && errors.push("Valor mínimo: 0");
      !this.$v.editedItem.cobertura_drp_reverso.maxValue && errors.push("Valor Máximo: 99.999.999");
      !this.$v.editedItem.cobertura_drp_reverso.integer && errors.push("Apenas números inteiro");
      return errors;
    },
    tempoRessuprimentoDrpReversoErrors() {
      const errors = [];
      if (!this.$v.editedItem.tempo_ressuprimento_drp_reverso.$dirty) return errors;
      !this.$v.editedItem.tempo_ressuprimento_drp_reverso.minValue && errors.push("Valor mínimo: 0");
      !this.$v.editedItem.tempo_ressuprimento_drp_reverso.maxValue && errors.push("Valor máximo: 99999999");
      !this.$v.editedItem.tempo_ressuprimento_drp_reverso.integer && errors.push("Apenas números inteiros");
      return errors;
    },
    limiteCoberturaErrors() {
      const errors = [];
      if (!this.$v.editedItem.limite_cobertura.$dirty) return errors;
      !this.$v.editedItem.limite_cobertura.minValue && errors.push("Valor mínimo: 0");
      !this.$v.editedItem.limite_cobertura.maxValue && errors.push("Valor máximo: 99999999");
      !this.$v.editedItem.limite_cobertura.integer && errors.push("Apenas números inteiros");
      return errors;
    },
    limiteDistribuicaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.limite_distribuicao.$dirty) return errors;
      !this.$v.editedItem.limite_distribuicao.minValue && errors.push("Valor mínimo: 0");
      !this.$v.editedItem.limite_distribuicao.maxValue && errors.push("Valor máximo: 99999999");
      !this.$v.editedItem.limite_distribuicao.integer && errors.push("Apenas números inteiros");
      return errors;
    },
    limiteCoberturaReversoErrors() {
      const errors = [];
      if (!this.$v.editedItem.limite_cobertura_reverso.$dirty) return errors;
      !this.$v.editedItem.limite_cobertura_reverso.minValue && errors.push("Valor mínimo: 0");
      !this.$v.editedItem.limite_cobertura_reverso.maxValue && errors.push("Valor máximo: 99999999");
      !this.$v.editedItem.limite_cobertura_reverso.integer && errors.push("Apenas números inteiros");
      return errors;
    },
    limiteDistribuicaoReversoErrors() {
      const errors = [];
      if (!this.$v.editedItem.limite_distribuicao_reverso.$dirty) return errors;
      !this.$v.editedItem.limite_distribuicao_reverso.minValue && errors.push("Valor mínimo: 0");
      !this.$v.editedItem.limite_distribuicao_reverso.maxValue && errors.push("Valor máximo: 99999999");
      !this.$v.editedItem.limite_distribuicao_reverso.integer && errors.push("Apenas números inteiros");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova Filial" : "Editar Filial";
    },
    ALTURA_TABELA() {
      const altura_config = '275px';
      const altura_parametrizacao = '230px';

      return this.$route.meta.layout == 'parametrizacao' ? `calc(100vh - ${altura_parametrizacao})` : `calc(100vh - ${altura_config})`;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    atualizarGrupoFilial() {
      this.initialize();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      Api.getGrupoFilial(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.desserts = response.data.grupoFilial;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      Api.getGrupos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.grupos.items = response.data.grupos;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      Api.getFilial(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.filias.items = response.data.filias;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      this.$store.dispatch("loading/habilitarLoading", false);
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover o Grupo?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          Api.delGrupoFilial(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }

      this.close();
    },

    close() {
      this.dialog = false;
      this.$v.$reset();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          Api.addGrupoFilial(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );

        this.close();
      }
    },
  },
};
</script>
<style scoped>
</style>
